module.exports = __webpack_public_path__ + "static/media/fontfamily.fc192fa6.svg";